import React, { useEffect, useRef, useState } from 'react'
import { filteredCategories, handleAddSingleDataFormData, handleBlurData, handleInputChangeData, handleUpdateSingleData, handleUpdateSingleDataUrlEncoded, resetFormData } from '../../../Utils/helper';
import { getApi } from '../../../Services/apiService';

function EditProduct({formData,productCategory,setMethodType,type,setFormData,formDataCopy,productToEdit,setError,originData,touched,setTouched,fetchProducts,setIsLoading,errors,isLoading,setSearchTerm,searchTerm,filterDatas,setFilterData}) {
  const dropdownRef = useRef()
    const [showStatusOptions ,setShowStatusOptions] = useState(false)
    const [showCategoryOptions ,setShowCategoryOptions] = useState(false)
    const [showCooOptions ,setShowCooOptions] = useState(false)
    const requiredFields=[ 
        // 'brand',
        // 'brand_code',
        'category',
        'coo',
        // 'category_id',
        'category_code',
        'code',
        // 'company_product_id',
        // 'company_product_id_code',
        // 'coo_id',
        'coo_code',
        // 'gross_Weight_unit',
        // 'gross_weight_value',
        // 'logistics_fee_Calculation_mode',
        'name_en',
        'name_tc',
        // 'net_weight',
        // 'pic_staff_member_import',
        // 'pic_staff_member_sales',
        'pid',
        // 'quantity_per_packaging_unit',
        // 'remarks',
        // 'specification',
        // 'specification_code',
        'status',
        // 'type',
        'variety',
        // 'varietyCode'
    ]
    useEffect(()=>{
        if(type==='view'){
        handleGetEditData()
        }
        // handleChange()
    },[])

    const handleGetEditData = async() =>{
        const resp = await getApi(`/product/${productToEdit?.id}`)
        if(resp?.success){
            setFormData(resp?.data?.product)
        }
        const selectedCategory = productCategory.find(
          cat => cat.id === resp?.data?.product?.category_id
          );
          handleChange('category_code', selectedCategory?.code);
          handleChange('category', selectedCategory?.name);
          handleChange('category_id', selectedCategory?.id);
      const selectedOrigin = originData.find(
          cat => cat.id === resp?.data?.product?.coo_id
          );
          handleChange('coo_code', selectedOrigin?.code);
          handleChange('coo', selectedOrigin?.name);
          handleChange('coo_id', selectedOrigin?.id);
    }

    const handleChange = (name, value) => {
        // const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      };

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowCategoryOptions(false)
            setShowCooOptions(false)
            setShowStatusOptions(false)
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);
    
      useEffect(() => {
        if (searchTerm !== '') {
          filterData()
        }
      }, [searchTerm])
    
      const filterData = () => {
       if (showCategoryOptions) {
          const data = filteredCategories(searchTerm, productCategory);
          setFilterData(data?.length > 0 ? data : []);
        } else if (showCategoryOptions) {
          const data = filteredCategories(searchTerm, originData);
          setFilterData(data?.length > 0 ? data : []);
        }
      }

  return (
    <div class="row">
    <div class="col-sm-12">
        <div class="setting-right position-relative setting-right-table">
            <h3>{type==='edit'?'Edit':(type==='view'?'View':'Add')} Product</h3>
            <img src={window.getPublicUrl('/assets/images/close.svg')} class="close" alt="" onClick={() => {
  setMethodType('');
  resetFormData(setFormData, setError,productToEdit,formDataCopy);
  setError(null)
}}/>
            <div class="setting-inner">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="productCode">Code<strong>*</strong></label>
                            <input type="text" id="productCode" class="form-control" placeholder="Enter Code" name='code' value={formData?.code} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                           
                        { errors?.code && (
                        <div className="invalid-feedback d-block">{errors.code}</div>
                      )}
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="pid">PID<strong>*</strong></label>
                            <input type="text" id="pid" class="form-control" placeholder="Enter PID" name='pid' value={formData?.pid} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                            {errors?.pid && (
                        <div className="invalid-feedback d-block">{errors.pid}</div>
                      )}
                        </div>
                    </div>


                    {/* <div className="col-sm-4">
                    <div className="form-group">
                      <label>
                      Status<strong>*</strong>
                      </label>
                       <div className='selctions-option position-relative' >
                        <input placeholder="category" class="w-100 category affter-change-cs category-select" value=" Select Status" />
                        <div className='select-option w-100'>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox"/>
                                <span class="checkmark" ></span>
                              </label>
                              Select Status
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox"/>
                                <span class="checkmark" ></span>
                              </label>
                              Active
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox"/>
                                <span class="checkmark" ></span>
                              </label>
                              Inactive
                            </span>
                        </div>

                      </div>
                    </div>
                  </div> */}

<div className="col-sm-4">
  <div className="form-group">
    <label>
      Status<strong>*</strong>
    </label>
    <div className='selctions-option position-relative'>
      <input
        type="text"
        placeholder="Select Status"
        readOnly
        className={`w-100 category affter-change-cs form-control category-select ${errors?.status ? 'is-invalid' : ''}`}
        value={
          formData?.status
            ? formData.status.charAt(0).toUpperCase() + formData.status.slice(1)
            : 'Select Status'
        }
        onClick={() => type !== 'view' && setShowStatusOptions(!showStatusOptions)}
        onBlur={(e) => {
          handleBlurData(e, setTouched, setError);
        }}
        name="status"
        disabled={type === 'view'}
      />
      {showStatusOptions && (
        <div className='select-option w-100' ref={dropdownRef}>
          {['active', 'inactive'].map((option) => (
            <span key={option} onClick={() => {
              const e = { target: { name: 'status', value: option } };
              handleInputChangeData(e, setFormData, touched, setError);
              setShowStatusOptions(false);
            }}>
              <label className="checbox-cs">
                <input
                  type="checkbox"
                  readOnly
                  checked={formData?.status === option}
                />
                <span className="checkmark"></span>
              </label>
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </span>
          ))}
        </div>
       )}
    </div>
    {errors?.status && (
      <div className="invalid-feedback d-block">{errors.status}</div>
    )}
  </div>
</div>






                    {/* <div class="col-sm-4">
                        <div class="form-group">
                            <label for="status">Status<strong>*</strong></label>
                            <select id="status" class="form-control" name='status' value={formData?.status} onChange={(e) => {
handleInputChangeData(e,setFormData,touched,setError);
// handleChange('status', e.target.value);
}}
 onBlur={(e)=>handleBlurData(e,setTouched,setError)}
>
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            { errors?.status && (
                        <div className="invalid-feedback d-block">{errors.status}</div>
                      )}
                        </div>
                    </div> */}

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="nameEn">Name (EN)<strong>*</strong></label>
                            <input type="text" id="nameEn" class="form-control"
                                placeholder="Enter Product Name" name='name_en' value={formData?.name_en} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                                 { errors?.name_en && (
                        <div className="invalid-feedback d-block">{errors.name_en}</div>
                      )}
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="nameTc">Name (TC)<strong>*</strong></label>
                            <input type="text" id="nameTc" class="form-control"
                                placeholder="Enter Product Name" name='name_tc' value={formData?.name_tc} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                                 {errors?.name_tc && (
                        <div className="invalid-feedback d-block">{errors?.name_tc}</div>
                      )}
                        </div>
                    </div>

                    <div class="col-sm-4">
  <div className="form-group">
    <label>Category<strong>*</strong></label>
    <div className='selctions-option position-relative'>
      <input
        placeholder="Category"
        className={`w-100 category affter-change-cs form-control category-select ${touched?.category && errors?.category ? 'is-invalid' : ''}`}
        value={!showCategoryOptions ?formData?.category:searchTerm}
        onClick={() => {
          if (type !== 'view') {
            setShowCategoryOptions(!showCategoryOptions);
            setSearchTerm('');
          }
        }}
        onChange={(e)=>setSearchTerm(e?.target?.value)}
        disabled={type === 'view'}
      />
      {showCategoryOptions &&
      <div className='select-option w-100' ref={dropdownRef}>
        
        {(searchTerm==='' ? productCategory?.length >0 :filterDatas?.length>0) ?(searchTerm===''?productCategory:filterDatas).map((x) => (
          <span key={x.id}>
            <label className="checbox-cs">
              <input
                type="checkbox"
                checked={formData?.category === x.name}
                onChange={() => {
                  const e = {
                    target: {
                      name: 'category',
                      value: x.name
                    }
                  };
                  handleInputChangeData(e, setFormData, touched, setError);
                  handleChange('category_code', x.code);
                  handleChange('category_id', x.id);
                  handleBlurData(e, setTouched, setError);
                  setShowCategoryOptions(false)
                }}
              />
              <span className="checkmark"></span>
            </label>
            {x.name}
          </span>
        ))
        :
      <span className="no-data-available">No Category Available</span>
      }
      </div>
}
    </div>
    {errors?.category && (
      <div className="invalid-feedback d-block">{errors.category}</div>
    )}
  </div>
</div>

                    {/* <div class="col-sm-4">
                        <div class="form-group">
                            <label for="category">Category<strong>*</strong></label>
                            <select id="category" class="form-control" name='category' onChange={(e) => {
const selectedCategory = productCategory.find(
cat => cat.name === e.target.value
);
handleInputChangeData(e,setFormData,touched,setError);
handleChange('category_code', selectedCategory?.code);
handleChange('category_id', selectedCategory?.id);
}} value={formData?.category} onBlur={(e)=>handleBlurData(e,setTouched,setError)}>
                                <option value="">Select Category</option>
                                {productCategory && productCategory?.length>0 && productCategory.map((x,index)=>{
                                    return(
                                <option value={x?.name}>{x?.name}</option>
                                    )
                                })}
                            </select>
                            { errors?.category && (
                        <div className="invalid-feedback d-block">{errors.category}</div>
                      )}
                        </div>
                    </div> */}

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="categoryCode">Category Code<strong>*</strong></label>
                            <select id="categoryCode" class="form-control" name='category_code' value={formData?.category_code} disabled>
                                <option value="">Select Category Code</option>
                                {productCategory && productCategory?.length>0 && productCategory.map((x,index)=>{
                                    return(
                                <option value={x?.code}>{x?.code}</option>
                                    )
                                })}
                            </select>
                            {/* { errors?.category_code && (
                        <div className="invalid-feedback d-block">{errors.category_code}</div>
                      )} */}
                        </div>
                    </div>

                    <div className="col-sm-4">
  <div className="form-group">
    <label>COO<strong>*</strong></label>
    <div className='selctions-option position-relative '>
      <input
        placeholder="COO"
        className={`w-100 category affter-change-cs form-control category-select ${touched?.coo && errors?.coo ? 'is-invalid' : ''}`}
        value={!showCooOptions ?formData?.coo :searchTerm}
        onClick={() => {
          if (type !== 'view') {
            setShowCooOptions(!showCooOptions);
            setSearchTerm('');
          }
        }}
        onChange={(e)=>setSearchTerm(e?.target?.value)}
        disabled={type === 'view'}
      />
      {showCooOptions &&
      <div className='select-option w-100' ref={dropdownRef}>
        {(searchTerm==='' ? originData?.length >0 :filterDatas?.length>0) ?(searchTerm===''?originData:filterDatas).map((x) => (
          <span key={x.id}>
            <label className="checbox-cs">
              <input
                type="checkbox"
                checked={formData?.coo === x.name}
                onChange={() => {
                  const selectedOrigin = originData.find(cat => cat.name === x.name);
                  const e = {
                    target: {
                      name: 'coo',
                      value: x.name
                    }
                  };
                  handleInputChangeData(e, setFormData, touched, setError);
                  handleChange('coo_code', selectedOrigin?.code);
                  handleChange('coo_id', selectedOrigin?.id);
                  handleBlurData(e, setTouched, setError);
                  setShowCooOptions(false)
                }}
              />
              <span className="checkmark"></span>
            </label>
            {x.name}
          </span>
        ))
        :
      <span className="no-data-available">No Coo Available</span>
      }
      </div>
}
    </div>
    {errors?.coo && (
      <div className="invalid-feedback d-block">{errors.coo}</div>
    )}
  </div>
</div>

                    {/* <div class="col-sm-4">
                        <div class="form-group">
                            <label for="coo">COO<strong>*</strong></label>
                            <select id="coo" class="form-control" name='coo' onChange={(e) => {
const selectedOrigin = originData.find(
cat => cat.name === e.target.value
);
handleInputChangeData(e,setFormData,touched,setError);
handleChange('coo_code', selectedOrigin?.code);
handleChange('coo_id', selectedOrigin?.id);
}} value={formData?.coo} onBlur={(e)=>handleBlurData(e,setTouched,setError)}>
                                <option value="">Select Coo</option>
                                {originData && originData?.length>0 && originData.map((x,index)=>{
                                    return(
                                <option value={x?.name}>{x?.name}</option>
                                    )
                                })}
                            </select>
                            { errors?.coo && (
                        <div className="invalid-feedback d-block">{errors.coo}</div>
                      )}
                        </div>
                    </div> */}

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="cooCode">COO Code<strong>*</strong></label>
                            <input type="text" id="cooCode" class="form-control" placeholder="Enter COO Code" name='coo_code' value={formData?.coo_code} disabled/>
                            {/* {errors?.coo_code && (
                        <div className="invalid-feedback d-block">{errors.coo_code}</div>
                      )} */}
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="variety">Variety<strong>*</strong></label>
                            <input type="text" id="variety" class="form-control" placeholder="Enter Variety" name='variety' value={formData?.variety} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                            {errors?.variety && (
                        <div className="invalid-feedback d-block">{errors.variety}</div>
                      )}
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="varietyCode">Variety Code</label>
                            <input type="text" id="varietyCode" class="form-control"
                                placeholder="Enter Variety Code" name='varietyCode' value={formData?.varietyCode} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="type">Type</label>
                            <input type="text" id="type" class="form-control" placeholder="Enter Type" name='type' value={formData?.type} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="companyProductId">Company Product ID</label>
                            <input type="text" id="companyProductId" class="form-control"
                                placeholder="Enter Product ID" name='company_product_id' value={formData?.company_product_id} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="companyProductIdCode">Company Product ID Code</label>
                            <input type="text" id="companyProductIdCode" class="form-control"
                                placeholder="Enter Company Product ID Code" name='company_product_id_code' value={formData?.company_product_id_code} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="brand">Brand</label>
                            <input type="text" id="brand" class="form-control" placeholder="Enter Brand" name='brand' value={formData?.brand} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="brandCode">Brand Code</label>
                            <input type="text" id="brandCode" class="form-control"
                                placeholder="Enter Brand Code" name='brand_code' value={formData?.brand_code} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="netWeight">Net Weight</label>
                            <input type="text" id="netWeight" class="form-control"
                                placeholder="Enter Net Weight" name='net_weight' value={formData?.net_weight} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="specification">Specification</label>
                            <input type="text" id="specification" class="form-control"
                                placeholder="Enter Specification" name='specification' value={formData?.specification} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="specificationcode">Specification Code</label>
                            <input type="text" id="specificationcode" class="form-control"
                                placeholder="Enter Specification Code" name='specification_code' value={formData?.specification_code} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>


                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="grossWeight">Gross Weight Value</label>
                            <input type="text" id="grossWeight" class="form-control"
                                placeholder="Enter Gross Weight Value" name='gross_weight_value' value={formData?.gross_Weight_value || formData?.gross_weight_value} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="grossWeightUnit">Gross Weight Unit</label>
                            <input type="text" id="grossWeightUnit" class="form-control"
                                placeholder="Enter Unit" name='gross_Weight_unit' value={formData?.gross_Weight_unit || formData?.gross_weight_unit} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="quantityPerUnit">Quantity Per Packaging Unit</label>
                            <input type="text" id="quantityPerUnit" class="form-control"
                                placeholder="Enter Quantity" name='quantity_per_packaging_unit' value={formData?.quantity_per_packaging_unit} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="logisticsMode">Logistics Fee Calculation Mode</label>
                            <input type="text" id="logisticsMode" class="form-control"
                                placeholder="Enter Logistics Mode" name='logistics_fee_Calculation_mode' value={formData?.logistics_fee_calculation_mode} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="remarks">Remarks</label>
                            <input type="text" id="remarks" class="form-control" placeholder="Enter Remarks" name='remarks' value={formData?.remarks} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="picstaffmember">PIC Staff Member (Import)</label>
                            <input type="text" id="picstaffmember" class="form-control"
                                placeholder="Enter PIC   Staff Member (Import)" name='pic_staff_member_import' value={formData?.pic_staff_member_import} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="picstaffmembersales">PIC Staff Member (Sales)</label>
                            <input type="text" id="picstaffmembersales" class="form-control"
                                placeholder="Enter PIC   Staff Member (Import)" name='pic_staff_member_sales' value={formData?.pic_staff_member_sales} onChange={(e)=>handleInputChangeData(e,setFormData,touched,setError)} onBlur={(e)=>handleBlurData(e,setTouched,setError)} disabled={type === 'view'}/>
                        </div>
                    </div>

                </div>
            </div>

            <div class="button-settings">
                <div class="col-sm-12">
                    <div class="d-flex justify-content-end gap-3">
                        {type === 'view' ? (
                            <button class="reset" onClick={() => setMethodType('')}>Back</button>
                        ) : (
                            <>
                                <button class="reset" onClick={()=>{resetFormData(setFormData, setError,productToEdit,formDataCopy);handleGetEditData()}}>Reset</button>
                                {type==='edit'?
                                <button class="save" onClick={() => handleUpdateSingleDataUrlEncoded(productToEdit,setIsLoading,fetchProducts,formData,setMethodType,setFormData,setError,setTouched,`/product/${productToEdit?.id}`,'product',formDataCopy,requiredFields)} disabled={isLoading}>{isLoading ? 'Saving...' : 'Save'}</button>
                                :
                                <button class="save" onClick={() => handleAddSingleDataFormData(setIsLoading,fetchProducts,formData,setMethodType,setFormData,setError,setTouched,`/product`,'product',formDataCopy,requiredFields)} disabled={isLoading}>{isLoading ? 'Saving...' : 'Save'}</button>
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default EditProduct